import PropTypes from 'prop-types';
import React, {
    useMemo,
    useState,
    useEffect,
    useContext,
    createContext,
} from 'react';

import { useGetClo } from 'src/api/clo';

const CloContext = createContext();

// Proveedor del contexto
export const CloProvider = ({ children }) => {
    const { clo, cloLoading, cloError } = useGetClo();
    const [cloData, setCloData] = useState(null);

    useEffect(() => {
        setCloData(clo);
    }, [clo]);

    // useMemo para evitar que el objeto `value` cambie en cada render
    const value = useMemo(() => ({
        clo: cloData,
        cloLoading,
        cloError,
    }), [cloData, cloLoading, cloError]);

    return (
        <CloContext.Provider value={value}>
            {children}
        </CloContext.Provider>
    );
};

// Validación de PropTypes
CloProvider.propTypes = {
    children: PropTypes.node.isRequired,
};

// Hook para usar el contexto en los componentes
export const useCloContext = () => useContext(CloContext);